import styled, { css, keyframes } from 'styled-components'
import type { SkeletonProps, SkeletonShapeProps } from './types'

const getDimension = (dimension: number | string) => {
  if (typeof dimension === 'string') return dimension
  if (typeof dimension === 'number') return `${dimension}px`
}

const animationPulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`

export const Skeleton = styled.div<{
  $aligment: SkeletonProps['aligment']
  $gap: SkeletonProps['gap']
}>`
  display: grid;

  ${({ $gap }) =>
    $gap &&
    css`
      gap: ${$gap}px;
    `}

  ${({ $aligment }) =>
    $aligment === 'horizontal' &&
    css`
      grid-auto-columns: min-content;
      grid-auto-flow: column;
    `}
`

export const Shape = styled.div<{
  $variant: SkeletonShapeProps['variant']
  $radius: SkeletonShapeProps['radius']
  $width: number | string
  $height: number | string
}>`
  background-color: var(--bg-transparent-strong);
  background-size: 300% 300%;
  animation: ${animationPulse} 1s ease-in-out infinite alternate;
  width: ${({ $width }) => getDimension($width)};
  height: ${({ $height }) => getDimension($height)};
  border-radius: var(--radius-brand);

  ${({ $radius }) =>
    $radius &&
    css`
      border-radius: ${$radius};
    `}
`
